<template>
  <ul
    class="list-disc text-[15px] leading-6 text-lgmx_black-200 marker:text-[32px] marker:text-lgmx_slate-100"
  >
    <slot />
  </ul>
</template>

<script setup></script>
